module.exports = __webpack_public_path__ + "img/analucia.a9b1b658.png";